export default __webpack_public_path__ + "static/media/Honored Helm of Passing Spirits.759535d9.jpg";